module.exports = __webpack_public_path__ + "img/tavolo.d5d9a322.svg";